import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { VaultobjectPopupScreenComponent } from "./../vaultobject-popup-screen/vaultobject-popup-screen.component";
import { ErrorMessages } from "./../../shared/common/errormessages";
import { Actionbutton } from "./../../shared/common/Actionbutton";
import { MatDialog } from "@angular/material/dialog";
import { constants } from "./../../shared/common/contants";
import { LocalStorageSettingsService } from "./../../shared/services/local-storage-settings.service";
import { Component, OnInit } from "@angular/core";
import { VaultObjectgroupService } from "../vaultobject-popup-screen/vault-objectgroup.service";
import { VaultobjectgroupchildComponent } from "../vaultobjectgroupchild/vaultobjectgroupchild.component";
import { VaultobjectPopupScreenExtractiongrpComponent } from "../vaultobject-popup-screen-extractiongrp/vaultobject-popup-screen-extractiongrp.component";
import { VaultobjectgroupchildextractionComponent } from "../vaultobjectgroupchildextraction/vaultobjectgroupchildextraction.component";
import { FileUploadButton } from "src/app/shared/common/fileUploadbutton";
import { FiledownloadComponent } from "src/app/shared/common/filedownload.component";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { JMigratorService } from "../jmigrator-tools/JMigrator.Service";
import {UserRoutingModule} from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from 'src/app/user/reportlinks/reportlinksservice.service';
import { ImportJsonComponent } from "src/app/shared/common/ImportJsonComponent ";

@Component({
    selector: "app-vaultobjectgroup",
    templateUrl: "./vaultobjectgroup.component.html",
    styleUrls: ["./vaultobjectgroup.component.scss"],
    standalone: false
})
export class VaultobjectgroupComponent implements OnInit {
  columnDefs;
  components: any;
  rowSelection;
  paginationPageSize;
  backgroundColorScreen = "";
  buttonColor = "";
  defaultColDef;
  rowClassRules;
  rowbindingdata;
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  paginationNumberFormatter;
  ngModelObjectDivision = [];
  ngModelObject = [];
  tableName = "";
  dynamicData = [];
  retrieveObject: any = [];
  grid;
  objectData: any = [];
  datasetobjectattributes: [];
  pagesiz;
  onBtExport;
  pagesize;
  rowdata: any = [];
  editmode: boolean = false;
  gridApi;
  pageSize;
  reportCreationData: any = [];
  headerNameHtml = "";
  validation_messages;
  deleteData: any = [];
  groupName: any;
  objectGroupData: any = [];
  status: any;
  value;
  selectedOptionForRadioBtn: string = "Extraction Group"
  tempevent;
  buttonIdList: any = [];
  selectedFileName='';
  listOfSourceDNS:any=[]
  fileUploaded = false;
  uploadTemplateEnabled: boolean;
  importExportTableNameMstr = "mstrobjectgroup";
  importExportTableNameChile = "objectgroup";
  
  // reportCreationData={"description":"", "groupname":"",objectid: []}

  constructor(
    private userRoutingModule:UserRoutingModule,
    private reportLinkService:ReportlinksserviceService,
    private migratorService: JMigratorService,
    private restApi: RestApi,
    private localStorageSettings: LocalStorageSettingsService,
    private constants: constants,
    private dialog: MatDialog,
    private vaultObjectService: VaultObjectgroupService,
    private commonService: CommonService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private msg: ErrorMessages
  ) {
    this.components = {
      buttonRenderer: Actionbutton,
      FileUploadButtonRenderer: FileUploadButton,
      fileDownloadButtonRendered: FiledownloadComponent
    };
    this.validation_messages = this.msg.reportConfiguration;
  }

  // onOptionChangeRadioBtn(option: string) {

  //   if (option === 'Extraction Group') {

  //     // Change selected option to Extraction Group if user selects 'Extraction Group'
  //     this.selectedOptionForRadioBtn = 'Extraction Group';
  //     this.onGridReady(this.tempevent);

  //   } else {
  //     this.selectedOptionForRadioBtn = 'Extraction Group';
  //     this.onGridReady(this.tempevent);
  //   }
  //   this.onGridReady(this.tempevent);
  //    console.log("==========="+this.selectedOptionForRadioBtn);
  // }

  ngOnInit() {
    
    /* @added by Chandra R
        @date 01-01-2025
        @@desc Below code enable and disable the buttons  in UI based on permission
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });




    this.columnDefs = [
      {
        headerName: "Action",
        filter: false,
        cellRenderer: "buttonRenderer",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        },
        width: 150,
      },
      {
        headerName: "Object Id",
        headerTooltip: "Object Id",
        tooltipValueGetter: (params) => "Object Id : " + params.value,
        field: "objectGroupId",
        filter: "agTextColumnFilter",
        width: 110,
      },
      {
        headerName: "Group Name",
        headerTooltip: "Group Name",
        tooltipValueGetter: (params) => "Group Name: " + params.value,
        field: "objectGroupName",
        filter: "agTextColumnFilter",
        width: 250,
        suppressSizeToFit: true,
      },
      {
        headerName: "Group Description",
        headerTooltip: "Group Description",
        tooltipValueGetter: (params) => "Group Description : " + params.value,
        field: "description",
        filter: "agTextColumnFilter",
        width: 300,
        suppressSizeToFit: true,
      },
      {
        headerName: "Created Date and Time",
        headerTooltip: "Created Date and Time",
        tooltipValueGetter: (params) => "Created Date and Time : " + params.value,
        field: "createdDateTime",
        filter: "agTextColumnFilter",
        width: 250,
      },
      {
        headerName: "Status",
        headerTooltip: "Status",
        tooltipValueGetter: (params) => "Status : " + params.value,
        field: "status",
        filter: "agTextColumnFilter",
        width: 150,
              cellStyle: (params) => {
      if (params.value === 'Yes') {
        return { 
          color: 'green', 
         
          'text-align': 'center'
        };
      } else if (params.value === 'No') {
        return { 
          color: 'red', 
         
          'text-align': 'center'
        };
      }
      return null;
    
  }
      },
      {
        headerName: "Partition by",
        headerTooltip: "Partition by",
        tooltipValueGetter: (params) => "Partition by : " + params.value,
        field: "csvtojsoncsvpartitionname",
        filter: "agTextColumnFilter",
        width: 150,
      },{
        headerName: "Start Position",
        headerTooltip: "Start Position",
        tooltipValueGetter: (params) => "Start Position : " + params.value,
        field: "csvtojsonpartitionsubstringstartposition",
        filter: "agTextColumnFilter",
        width: 150,
      },{
        headerName: "Partition Length",
        headerTooltip: "Partition Length",
        tooltipValueGetter: (params) => "Partition Length : " + params.value,
        field: "csvtojsonpartitionsubstringlength",
        filter: "agTextColumnFilter",
        width: 150,
      },
      
      //  @modified by Aman Singh
      //   @date 20-05-2024
      //   @desc Added 2 new fields at obejct group level (extraction method and field from objectmetadata)
        
      
      {
        headerName: "Extraction Method",
        headerTooltip: "Extraction Method",
        tooltipValueGetter: (params) => "Extraction Method : " + params.value,
        field: "extractionsource",
        filter: "agTextColumnFilter",
        width: 150,
        
      },{
        headerName: "Fields From Objectmetadata",
        headerTooltip: "Fields From Objectmetadata",
        tooltipValueGetter: (params) => "Fields From Objectmetadata : " + params.value,
        field: "fieldsfromobjectmetadata",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: "CSV Extraction Method",
        headerTooltip: "CSV Extraction Method",
        tooltipValueGetter: (params) => "CSV Extraction Method : " + params.value,
        field: "csvextractionsource",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: "Transformation Mapping Template Generation status ",
        headerTooltip: "Transformation Mapping Template Generation status",
        tooltipValueGetter: (params) => "Transformation Mapping Template Generation status : " + params.value,
        field: "transformationmappingtemplatestatus",
        filter: "agTextColumnFilter",
        width: 150,
      },
      {
        headerName: "Upload Transformation Mapping Template and Generate Mapping file",
        headerTooltip: "Upload Transformation Mapping Template and Generate Mapping file",
        tooltipValueGetter: (params) => "Upload Transformation Mapping Template and Generate Mapping file",
        //field: "status",
        filter: "agTextColumnFilter",
        width: 150,
        cellRenderer: "FileUploadButtonRenderer",
        cellRendererParams: {
          uploadSourceFile: this.uploadMappingFile.bind(this)

        },
      },
      {
        headerName: "Download Transformation Mapping Template",
        headerTooltip: "Download Transformation Mapping Template",
        tooltipValueGetter: (params) => "Download Transformation Mapping Template",
        ///  field: "status",
        filter: "agTextColumnFilter",
        width: 150,
        cellRenderer: "fileDownloadButtonRendered",
        cellRendererParams: {
          docdownload: this.downloadMappingFile.bind(this)

        },
      },
    ];
    // if the record has status==no , row color will change
  // Fix the rowClassRules in ngOnInit
    this.rowClassRules = {
    // For status 'No' cells - red color
    'status-inactive': function(params) {
      const status = params.data.status;
      return status === "No" || status === "false" || status === false;
    },
    // For status 'Yes' cells - green color
    'status-active': function(params) {
      const status = params.data.status;
      return status === "Yes" || status === "true" || status === true;
    },
    // For entire row styling of deleted records
    'deleted-row': function(params) {
      const status = params.data.status;
      return status === "No" || status === "false" || status === false;
    }

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true,
    };
    if (this.headerNameHtml === "Vault Objects") {
      this.paginationPageSize = this.constants.vaultpagesize;
    }
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };
    this.backgroundColorScreen =
      this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

  }

  onPaginationChanged() {
    if (this.gridApi) {
      this.lastpage = this.gridApi.paginationIsLastPageFound();

      this.currentpage = this.gridApi.paginationGetCurrentPage() + 1;

      this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1;

      this.nextpageplusone =
        this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalpages = this.gridApi.paginationGetTotalPages();
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridApi.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  async onBtNext() {
    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.paginationGoToNextPage();
  }

  // below function for going to previous page
  async onBtPrevious() {
    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridApi.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridApi.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridApi.paginationGoToLastPage();
  }
  //pagination code ends

  openSaveForm() {
    let width = "70%";
    let dialogData = {
      "selectedOptionForRadioBtn": this.selectedOptionForRadioBtn,
      "createGroupOption": "add btn"
    };
    let dialogRef = this.dialog.open(VaultobjectPopupScreenComponent, {
      maxWidth: "100vw",
      height: "90%",
      width: width,
      data: dialogData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

      this.reportCreationData = result;

      this.vaultObjectService.retrieveobjectgroup();
    });
  }

  openSaveForm2() {
    //alert("hi i am extraction")
    let width = "85%";
    let dialogRef = this.dialog.open(VaultobjectPopupScreenExtractiongrpComponent, {
      maxWidth: "100vw",
      height: "90%",
      width: width,
      data: { "selectedOptionForRadioBtn": this.selectedOptionForRadioBtn , "createGroupOption": "add btn"},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);

      this.reportCreationData = result;

      this.vaultObjectService.retrieveobjectgroup();
    });
  }

  async onGridReady(params) {
    // let tableName="vaultobjectgroup";
    // let response = await  this.commonService.retrieveRecordService(tableName);
    // console.log(response.data);
   
    this.tempevent = params;
    this.rowbindingdata = params;
    console.log("--------------", this.selectedOptionForRadioBtn);
    this.vaultObjectService.retrieveAllobjectgroup(this.localStorageSettings.getSettings("dnsName"), this.selectedOptionForRadioBtn).subscribe((res) => {
      console.log(res);
    this.objectData = this.sortObjectGroups(res);      console.log("Successfully");
      this.grid = params;
      console.log(params);
      this.gridApi = params.api;
      console.log(params.api);
      this.grid.api.setGridOption('rowData', this.objectData);
    });
    this.spinner.stop();
  }

      /*
    * Modified by Sujeet Sharma
    * @Date 23/10/2025
    * @Desc Added new helper method `sortObjectGroups()` to control record ordering.
    * - Sorts data so that:
    *   Active records (status = 'Yes') appear first.
    *   Deleted records (status = 'No') appear last.
    * - Within each group, sorts records by `objectGroupId` in descending order.
    * - Ensures UI grid displays latest active records first.
    */

    private sortObjectGroups(data: any[]): any[] {
      if (!data || data.length === 0) return data;
        return data.sort((a, b) => {
        const aIsActive = a.status === 'Yes' || a.status === 'true';
        const bIsActive = b.status === 'Yes' || b.status === 'true';
        if (aIsActive && !bIsActive) {
          return -1; 
        } else if (!aIsActive && bIsActive) {
          return 1; 
        } else {
          return (b.objectGroupId || 0) - (a.objectGroupId || 0);
    }
  });
}
  EditIcon(event) {
    if (this.selectedOptionForRadioBtn === "Extraction Group") {
      console.log(event);
      this.status = event.rowData.status;
      if (this.status == "Yes") {
        let width = "85%";
        this.dialog.open(VaultobjectgroupchildextractionComponent, {
          maxWidth: "100vw",
          height: "90%",
          width: width,
          data: { data: event,"createGroupOption": "edit btn" },
          disableClose: true,
        });
      } else {
        this.snackbar.open(
          "Cannot edit object group which is already deleted.",
          "OK",
          {
            duration: 8000,
          }
        );
      }
      console.log(event.rowData.objectgroupname);
      this.groupName = event.rowData.objectgroupname;
      this.vaultObjectService
        .retrieveAllobjectgroup(this.localStorageSettings.getSettings("dnsName"), this.selectedOptionForRadioBtn)
        .subscribe((result) => {
          console.log(result);
          this.objectGroupData = result;
          this.objectGroupData.api.setGridOption('rowData', result);
        });

    } else {

      console.log(event);
      this.status = event.rowData.status;
      if (this.status == "Yes") {
        let width = "70%";
        this.dialog.open(VaultobjectgroupchildComponent, {
          maxWidth: "100vw",
          height: "90%",
          width: width,
          data: { data: event },
          disableClose: true,
        });
      } else {
        this.snackbar.open(
          "Cannot edit object group which is already deleted.",
          "OK",
          {
            duration: 8000,
          }
        );
      }
      console.log(event.rowData.objectgroupname);
      this.groupName = event.rowData.objectgroupname;
      this.vaultObjectService
        .retrieveAllobjectgroup(this.localStorageSettings.getSettings("dnsName"), this.selectedOptionForRadioBtn)
        .subscribe((result) => {
          console.log(result);
          this.objectGroupData = result;
          this.objectGroupData.api.setGridOption('rowData', result);
        });

    }
  }


  /*
 * Modified by Sujeet Sharma
 * @Date 23/10/2025
 *  Enhanced deleteIcon() method for Object Group soft delete functionality.
 *  Performs soft delete by updating record status to 'No'.
 */

  deleteIcon(groupName) {
    console.log(groupName.rowData.status);
    this.status = groupName.rowData.status;
    if (this.status == "Yes") {
      if (confirm("Are you sure you want to delete the object group?")) {
        console.log(groupName.rowData.objectgroupname);
        const objectGroupId = groupName.rowData.objectGroupId;
          const tenantId = this.localStorageSettings.getSettings("dnsName");

          this.spinner.start();
          this.vaultObjectService.deleteObjects(objectGroupId, tenantId)
          .subscribe((res) => {
            console.log(res);
             this.vaultObjectService.retrieveAllobjectgroup(
          this.localStorageSettings.getSettings("dnsName"), 
          this.selectedOptionForRadioBtn
        ).subscribe((freshData) => {
          // Apply sorting to the fresh data
          this.objectData = this.sortObjectGroups(freshData);
          this.gridApi.setGridOption('rowData', this.objectData);
          
          this.snackbar.open(res.statusMessage, "OK", {
            duration: 5000,
          });
          this.spinner.stop();
        });
        
      }, (err) => {
        this.spinner.stop();
        this.snackbar.open("Unable to delete Object Group.", "OK", {
          duration: 5000,
        });
      });
    }

    } else {
      this.snackbar.open("This Object Group is already deleted.", "OK", {
        duration: 5000,
      });
    }
  }

  //excel export function
  downlod() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  uploadMappingFile(inputValue) {
    console.log(inputValue);
    console.log(inputValue.event.target)

    let tenantId = inputValue.rowData.tenantId;
    let objectGrpId = inputValue.rowData.objectGroupId;
    let ischeckfile = false
    var file: File = inputValue.event.target.files[0];
    var FileS: File = inputValue.event.target.files[0];
    console.log(file.type)
    if (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      ischeckfile = true
    }

    if (ischeckfile) {

      var fileName = FileS.name;
      //Modified by Geetha B, 14-08-2023
      //Sending the file data as a Multipart file in a form data

      const formData = new FormData();
      formData.append('file', file)

      formData.append('data', JSON.stringify({ fileName: fileName }))

      this.vaultObjectService.generateMappingFile(tenantId, objectGrpId, formData).subscribe(res => {
        console.log(res);
        if (res.error === true) {
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        } else {
          this.onGridReady(this.tempevent);
          this.spinner.stop();
          this.snackbar.open(res.statusMessage, "OK", { duration: 5000 });
        }
      })




    } else {
      this.snackbar.open(file.name + "is invalid file. Please select Excel file ", "OK", {
        duration: 5000,
      });
    }

  }


  zipDoc;


   downloadMappingFile(e) {
     console.log(e)

    console.log(e.rowData)
    console.log(this.restApi.zipanddownloadanyfilesFromS3 + "/" + e.rowData.transformationMappingTemplatePath + "/null")
//  this.vaultObjectService.downloadMappingFile(e.rowData.transformationMappingTemplatePath).subscribe(response =>{
//       console.log(response)
//     });
   // this.zipDoc = this.restApi.zipanddownloadanyfilesFromS3UsingPathOnly;

    if (e.rowData.transformationMappingTemplatePath === undefined || e.rowData.transformationMappingTemplatePath === "" || e.rowData.transformationMappingTemplatePath === null) {
      this.snackbar.open("Folder does not exist", "OK", {
        panelClass: 'snack'
      }
      );
    } else {
      this.spinner.start();
      console.log("======")
      this.migratorService.download_zip_ForPostUrl(this.restApi.zipanddownloadanyfilesFromS3UsingPathOnly,(JSON.stringify({"s3PathFull":e.rowData.transformationMappingTemplatePath})))
        .subscribe(x => {
          console.log(x)
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([x], { type: 'application/zip' });

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   window.navigator.msSaveOrOpenBlob(newBlob);
          //   return;
          // }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          console.log(data)
          var link = document.createElement('a');
          link.href = data;
          console.log(e.rowData.fileName)
          link.download = "converted.zip";
          console.log("ento")
          // this is necessary as link.click() does not work on the latest firefox
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
            link.remove();
          }, 100);
        });
      this.spinner.stop();
    }



   }


uploadGroupTemplate() {
  console.log("<--- Inside upload Group Template --->")
  let width = "85%";
  let dialogRef = this.dialog.open(VaultobjectPopupScreenExtractiongrpComponent, {
    maxWidth: "70vw",
    height: "50%",
    width: width,
    data: { "selectedOptionForRadioBtn": this.selectedOptionForRadioBtn , "createGroupOption": "upload btn"},
    disableClose: true,
  });

  dialogRef.afterClosed().subscribe((result) => {
    console.log(result);

    this.reportCreationData = result;

    this.vaultObjectService.retrieveobjectgroup();
  });
  }
  importData() {
     
        console.log("<--- Inside upload Group Template --->")
        let width = "85%";
      let dialogRef = this.dialog.open(ImportJsonComponent, {
          maxWidth: "70vw",
          height: "60%",
          width: width,
        data: { "tablename": this.importExportTableNameMstr},
          disableClose: true,
        });
      
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
      
          //this.reportCreationData = result;
      
          //this.vaultObjectService.retrieveobjectgroup();
        });
      
      
    }
    
  
    async exportData() {
      this.snackbar.open("Export Process is InProgress. Please do not click again the Export until it completes the Export.", "OK", { duration: 10000 });
      let tenantid = localStorage.getItem("dnsName")
     
  
        try {
          const blob = await this.commonService.downloadJsonFile(this.importExportTableNameMstr, tenantid);
          const link = document.createElement('a');
          const timestamp = new Date().getTime();
          link.href = window.URL.createObjectURL(blob);
          link.download = `${this.importExportTableNameMstr}_export_${timestamp}.json`;
          link.click();
          window.URL.revokeObjectURL(link.href);
  
        } catch (error) {
          console.error('Error downloading JSON:', error);
      }
      try {
        const blob = await this.commonService.downloadJsonFile(this.importExportTableNameChile, tenantid);
        const link = document.createElement('a');
        const timestamp = new Date().getTime();
        link.href = window.URL.createObjectURL(blob);
        link.download = `${this.importExportTableNameChile}_export_${timestamp}.json`;
        link.click();
        window.URL.revokeObjectURL(link.href);

      } catch (error) {
        console.error('Error downloading JSON:', error);
      }
      
      
    }
  


}
